import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Logo from 'components/logo';
import HeaderMenu from 'components/header-menu';
import QuickSearch from 'components/quick-search';
import { FocusTrap } from 'focus-trap-react';
import { imageSourceBreakpoints } from 'js/breakpoints';

const Header = ({ logo, headerMenu, quickSearch }) => {
  const [isHeaderMenuActive, setIsHeaderMenuActive] = useState(false);

  return (
    <div className="header">
      <FocusTrap active={isHeaderMenuActive}>
        <div className="header__container">
          {quickSearch && (
            <QuickSearch {...quickSearch} className="header__quick-search" />
          )}
          {logo && (
            <Logo
              {...logo}
              className="header__logo"
              image={
                logo.image
                  ? {
                      ...logo.image,
                      sources: [
                        {
                          width: 165,
                          height: 53,
                          media: imageSourceBreakpoints.m,
                        },
                        {
                          width: 250,
                          height: 80,
                          media: imageSourceBreakpoints.l,
                        },
                      ],
                      transform: 'fit',
                    }
                  : null
              }
              imageClass="image_size_header-logo"
            />
          )}

          {headerMenu && (
            <HeaderMenu {...headerMenu} onMenuToggle={setIsHeaderMenuActive} />
          )}
        </div>
      </FocusTrap>
    </div>
  );
};

Header.propTypes = {
  quickSearch: PropTypes.exact(QuickSearch.propTypes),
  logo: PropTypes.exact(Logo.propTypes),
  headerMenu: PropTypes.exact(HeaderMenu.propTypes),
};

export default Header;
